// 参考文档 https://www.eolinker.com/#/home/ams/project/inside/public/dataStructure/operate/edit?structureID=43989&projectName=%E5%8D%B3%E4%BA%ABH5&projectHashKey=jHxpHJN1cc5664df1af4de7aca290c58f6c64ce43842b07&spaceKey=SVChPRE8a044f298770622021d2ebc5724bc2f2a7b969c9
import { IGalleryStatus, IRootStore, ILocaleTextMap } from "./global.d";
import { CSSProperties, ReactNode } from "react";
import { IOneGallery } from "./components/GalleryList/Common";
import { IMedium } from "./store/VideoStore";
import RootStore from "store/RootStore";

// 组件通用父类
interface IComponent {
  cid: string; //组件ID
  type: string; // 组件类型
  container: IComponentContainer; // 参考container
  // [name: string]: any;
  buttons?: any[];
  onChange?: any;
  forceBg?: string; // 有些场景需要强制当前组件的背景，如果为'transparent'即透明，否则请给颜色值
  api?: string; //标识当前的版本
}

export interface IComponentEmpty extends IComponent {
  list?: IComponent[];
  direction: string;
  gap: number;
  rootStore?: RootStore;
}

export interface IComponentContainerPadding {
  paddingTop?: number | string;
  paddingBottom?: number | string;
  paddingLeft?: number | string;
  paddingRight?: number | string;
}

// 边距
export interface IComponentContainer extends IComponentContainerPadding {
  bottom: number | string;
  top: number | string;
  left: number | string;
  right: number | string;
  borderRadius?: number | string;
  useThemeColor?: boolean;
  componentBg?: string;
}

export interface IComponentIFrame extends IComponent {
  url: string;
  height: number;
}

// 链接
export interface IComponentLink {
  type: string;
  name?: string; // 当前组件的名字
  value?: string | number | IMediumWithLinkId;
  link_id?: string;
  galleryid?: string | number;
  url_labeling?: string;
  modalcontent?: string;
  modalauto?: boolean;
  modallink?: string;
  appid?: string;
  path?: string;
  desc?: string;
  desc_i18n?: ILocaleTextMap;
}

export interface IComponentGroupGallery extends IComponent {
  tabPosition: string;
  ids: any[];
  search: boolean;
  rootStore?: IRootStore;
}

interface IComponentXHead extends IComponent {
  total: boolean; // 是否显示统计信息
}

// 视频头图 type=videohead
export interface IComponentVideoHead extends IComponentXHead {
  source: string; // 视频链接，带http头的
  thumb: string; // 背景图
  total: boolean;
  videoid: number | string;
  imageviews?: number;
  imagecount?: number;
  rootStore?: IRootStore;
}

interface ISlide {
  link: IComponentLink;
  image: string;
}

// 轮播头图 type=slidehead
export interface IComponentSlideHead extends IComponentXHead {
  slides: ISlide[];
  pinch?: boolean; // 是否允许点击查看大图
  duration?: number; // 毫秒，轮播时间
  mode: string;
  rootStore?: IRootStore;
}

// 号码输入组件 type=formocr
export interface IComponentFormOcr extends IComponent {
  placeholder?: string;
  placeholder_i18n?: ILocaleTextMap;
  vectorSearchText?: string;
  searchButtonText?: string;
  searchButtonText_i18n?: ILocaleTextMap;
  vectorThreshold?: string | number;
}

// 富文本 type=text
// export interface IComponentText extends IComponent {
//   html: string;
// }

export enum IPendantButton {
  refresh = "refresh",
  people = "people",
  share = "share",
  setting = "setting",
  custom = "custom",
  top = "top", //置顶
  redpackage = "redpackage",
  jigsaw = "jigsaw",
  event = "event",
  good = "good",
  order = "order",
  lang = "lang",
  download = "download",
}
// 挂件 (注意这里的拼写使用的是Pendent,代码中其他地方都是用的Pendant,名字主要是根据后端来的，所以这里保持的Pendent了)
export interface IComponentPendent extends IComponent {
  buttons: {
    show: boolean;
    type: IPendantButton;
    image?: string; // 用户上传的图标地址，当且仅当type=custom时有效
    link?: IComponentLink; // 当且仅当type=custom时有效
  }[];
  api?: string;
}

// 底部导航 type='navigator'
export interface IComponentNavigator extends IComponent {
  my: boolean; // 是否显示“我的”
  order: boolean; // 是否显示预约
}

// 引导组件 type=guide
export interface IComponentGuide extends IComponent {
  image: string; // 背景图
  link: IComponentLink;
  showBar: boolean; //底部条是否可见
  autoPlay: boolean; //是否自动跳过
  duration?: number; //自动跳过时间(单位ms)
  barColor?: string;
  opacity?: number;
}

export interface IOneButton {
  type: string;
  image?: string;
  link?: string;
  desc?: string;
  content?: ReactNode | string;
  //[key:string]:any;
}
export interface IOneGuest {
  name: string;
  photo: string;
  desc?: string;
}
export interface IActInfo {
  edittype: string;
  content:
  | {
    time?: string;
    detail?: string;
    sponsor?: string;
    map?: {
      name: string;
      longitude: string;
      latitude: string;
    };
  }
  | ReactChild;
}
export interface IOneActFlow {
  type: string;
  title: string;
  time?: string;
  desc?: string;
}
export interface IActFlow {
  edittype: string;
  content: IOneActFlow[] | ReactChild;
}
export interface ISponsor {
  edittype: string;
  content: string;
}
// 按钮组 type=buttongroup
export interface IComponentButtonGroup extends IComponent {
  buttons: IOneButton[];
  guests: {
    edittype: string;
    content: IOneGuest[] | ReactChild;
  };
  actinfo: IActInfo;
  actflow: IActFlow;
  sponsor: ISponsor;
}

// 子相册列表 type=gallery
export interface IComponentGallery extends IComponent {
  list: {
    image: string;
    link: IComponentLink;
    desc?: string;
    desc_i18n?: ILocaleTextMap;
  }[];
  info?: boolean;
  total?: boolean;
  search?: boolean;
  showname?: boolean;
  namealign?: string;
  imageadjust?: boolean;
  mode: string; // 1,2,3,4 1:左侧图片，右侧文字; 2:一行两列;3:一行一列;4:纯文字
}

// type=photo 相册
export interface IComponentPhoto extends IComponent {
  mode: string; //模板类型
  disabletag?: boolean;
  disablesystem?: boolean;
  showhot?: boolean;
  showperson?: boolean;
  showall?: boolean;
}
// 发现存入的video只有这些字段
export interface ISimpleVideo {
  thumb: string; // 封面
  source: string; // 视频连接地址（需要检查是否还有http）
  desc: string; // 视频标题
  status: IGalleryStatus;
}
export interface ISimpleVideoWithId extends ISimpleVideo {
  id: number;
  type: string;
}
// 实在没办法了，为什么不得不定义这么多乱七八糟的结构
export interface IMediumWithLinkId extends IMedium {
  link_id: string;
}

// 视频 type=video
export interface IComponentVideo extends IComponent, ISimpleVideo {
  videoid: string | number;
  playin?: boolean; //playin 当为 true 时，表示当前页播放，否则跳转播放
  fullscreen?: boolean; // 如果在当前页播放，可能会造成显示问题，那么再次新增一个字段，默认全屏 fullscreen ，当为 true时，播放时尝试全屏播放
  notice?: boolean; // 是否开启了直播提醒
  islive?: boolean; // 是否为直播视频
  notice_image?: string; // 直播提醒的内容图片
  notice_text?: string;
}

// 标签页 type=tab
export interface IComponentTab extends IComponent {
  list: {
    title: string; // 标题
    title_i18n?: ILocaleTextMap;
    children: IComponent[]; // 组件
  }[];
  fixed?: boolean;
  mode: string;
  activeBg?: string; // 选中后的背景色
  activeOpacity?: number; // 选中后的背景透明度
  fontSize?: number; //字体大小（目前只允许top去调整）
  isBold?: boolean; //是否加粗 目前也只针对top
  rootStore?: RootStore;
}

// type=image
export interface IComponentImage extends IComponent {
  images: {
    link: IComponentLink;
    image: string; // 图片地址
    desc?: string;
    desc_i18n?: ILocaleTextMap;
  }[];
  mode: string; // 模板类型 1 2 3 4
}

// type=richtext
export interface IComponentText extends IComponent {
  richtext: string;
  richtext_i18n?: ILocaleTextMap;
}

// type=liverich
export interface IComponentLiveRich extends IComponent {
  rootStore?: RootStore;
  richhash: string;
}

// type=collapse
export interface IComponentCollapse extends IComponent {
  list: {
    title: string;
    title_i18n?: ILocaleTextMap;
    children: IComponent[];
    expand?: number;
  }[];
}

export interface IComponentActInfo extends IComponent, IActInfo {
  rootStore?: IRootStore;
  title: string;
  show_status: boolean;
  show_view: boolean;
  show_info: boolean;
}

export interface IComponentActFlow extends IComponent, IActFlow { }

export interface IComponentGuests extends IComponent {
  edittype: string;
  content: IOneGuest[] | ReactChild;
  onItemClick?: (data: IOneGuest) => void;
  title?: string;
}

export interface IComponentHotOne {
  tId: string; // 唯一标示
  image: string;
  link: IComponentLink;
  desc: string;
}
// 热门展商组件/热门图片组件
export interface IComponentHot extends IComponent {
  hot_list: IComponentHotOne[];
  template: string; // template1/template2
  title?: string;
  // 新增：数据来源与查看更多
  dataSource?: 'manual' | 'album'; // 数据来源
  gallery_list?: (string | number)[]; // 指定相册ID列表
  tag?: string; // 汇总标签
  sortType?: string; // shoot_time | upload_time | index
  sortOrder?: string; // asc | desc
  showMore?: boolean; // 是否显示"查看更多"
  showMoreType?: 'page' | 'url' | 'none'; // 跳转类型
  showMoreUrl?: string; // 自定义链接
  showMorePage?: string; // 页面名称/link_id
}

export interface IComponentMultiVideo extends IComponent {
  video_list: ISimpleVideoWithId[];
  title?: string;
  // danmuku: boolean; // 跟涵哥确认不允许弹幕
}

export interface IOneComponentHVideo {
  image: string;
  link: IComponentLink;
  desc: string;
  desc_i18n?: ILocaleTextMap;
}

export interface IComponentHVideoList extends IComponent {
  current_page_play?: boolean; // 是否在当前页播放
  list: IOneComponentHVideo[];
  info?: boolean;
  mode: string; // 1,2,3,4 1:左侧图片，右侧文字; 2:一行两列;3:一行一列;4:纯文字
  rootStore?: IRootStore;
}

export interface IComponentCommentSend extends IComponent {
  gift: boolean;
  emotion: boolean;
  question: boolean;
  rootStore?: IRootStore;
  cid: string;
  renderMode?: string;
}

export interface IComponentCommentList extends IComponent {
  theme: string;
  onlypage?: boolean;
  newuser?: boolean;
  rootStore?: IRootStore;
  cid: string;
}

export interface IComponentCode extends IComponent {
  css: string;
  js: string;
  rootStore?: IRootStore;
}

export interface IComponentCarousel extends IComponent {
  gallery_list?: string[]; // id list
}

export interface IComponentVideoH extends IComponent {
  desc?: string;
  type: string;
  thumb?: string;
  notice: boolean;
  source?: string;
  danmuku: boolean;
  video_id: number;
  notice_text?: string;
  notice_image?: string;
  rootStore?: IRootStore;
  wrapperStyle?: CSSProperties;
  onVideoPlay?: () => void;
  onVideoPause?: () => void;
}

export interface IComponentForm extends IComponent {
  submit: string;
  afteraction: string;
  submitBehavior?: IComponentLink;
  children: IComponent[];
  rootStore?: IRootStore;
  customRequest?: (data: any) => void;
  isPortraitMode?: boolean;
}

export interface IFormField {
  label: boolean;
  field: string;
  align: string;
  required: boolean;
  width: string;
  onChange: (field: string, value: any) => void;
  formData: any;
}

export interface IComponentInput extends IComponent, IFormField {
  placeholder: string;
  min: number;
  max: number;
}

export interface IComponentDate extends IComponent, IFormField { }

export interface IComponentTime extends IComponent, IFormField { }

export interface IComponentInvite extends IComponent, IFormField {
  placeholder: string;
}

export interface IComponentPassword extends IComponent, IFormField {
  placeholder: string;
  password: string;
}

export interface IComponentPhone extends IComponent, IFormField {
  placeholder: string;
  whitelist: boolean;
  world: boolean;
  rootStore?: RootStore;
}

export interface IComponentRadio extends IComponent, IFormField {
  select: string[];
}

export interface IComponentCheckbox extends IComponent, IFormField {
  select: string[];
}

export interface IComponentSelect extends IComponent, IFormField {
  select: string[];
  defaultValue?: string;
}

export interface IComponentTextarea extends IComponent, IFormField {
  placeholder: string;
  min: number;
  max: number;
  rows: number;
}

export interface IComponentPay extends IComponent {
  onChange: (type: string, field: string, value: any) => void;
  field: string;
  goods_id: number;
  rootStore?: RootStore;
  formData: any;
}

// 肖像权协议组件
export interface IComponentPortrait extends IComponent {
  onChange?: (type: string, field: string, value: any) => void;
  // 协议内容 - 富文本
  agreementContent: string;
  // 同意按钮文字
  agreeButtonText: string;
  // 是否显示授权成功页
  showSuccessPage: boolean;
  // 成功页内容 - 富文本
  successContent: string;
  // 进入相册按钮文字
  enterButtonText: string;
  // 倒计时秒数
  countdown: number;
  rootStore?: RootStore;
}

export interface IComponentDocument extends IComponent {
  component_cid: string | number;
  document_id: string | number;
  auto: boolean;
  rootStore?: RootStore;
}

export interface IComponentVote extends IComponent {
  vote_id: string | number;
  show_result: boolean;
  show_count: boolean;
  show_search: boolean;
  show_bigpic?: boolean;
  showtype?: string;
  static_order?: boolean;
  button_text?: string;
  mode: string;
  rootStore?: RootStore;
}

export interface IComponentLucky extends IComponent {
  lucky_id: number;
  mode: string;
  show_result: boolean;
  rootStore?: RootStore;
}

export interface IComponentContact extends IComponent {
  title: string;
  contacts: any[];
}

export interface IComponentLiveShow extends IComponent {
  title: string;
  hot: boolean;
  search: boolean;
  download: boolean;
  mode: string;
}

export interface IComponentLiveCut extends IComponent {
  title: string;
  view: boolean;
  search: boolean;
  download: boolean;
  mode: string;
  videos: any[];
}

export interface IComponentInviteUser extends IComponent {
  topx: number;
}

export interface IComponentMobileUpload extends IComponent {
  galleryname?: boolean;
  value?: number;
  title?: string;
  uploadTitle?: string;
  max?: number;
  rootStore?: RootStore;
  enableUploadToTag: boolean;
  remarkImage: boolean;
}

export interface IOnePosterModule {
  // 尺寸都相对750px而言
  left: number;
  top: number;
  width: number;
  height: number;
  bg_hash: string; // 背景图
}

export interface IComponentTagPhoto extends IComponent {
  gallery_list: string[];
  mode: string;
  tag?: string;
  sort_type?: string;
  sort_order?: 'asc' | 'desc';
  aggregate_type?: 'tag' | 'album';
  show_gallery_jumper?: boolean;
}
